module.exports = __webpack_public_path__ + "norbert.gif?bd164425e282c4587fb3d9018dafb94a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/norbert.gif
// module id = 49
// module chunks = 0